import { render } from "./Grupos.vue?vue&type=template&id=52a1eec4&scoped=true"
import script from "./Grupos.vue?vue&type=script&lang=js"
export * from "./Grupos.vue?vue&type=script&lang=js"

import "./Grupos.vue?vue&type=style&index=0&id=52a1eec4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a1eec4"]])

export default __exports__